import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoashtavinayakdarshancab() {



    const cardData = {

keyword: "Pune to Ashtavinayak Darshan Cab",

headingDescription:
    "Rising Cab Service offers safe and comfortable Pune to Ashtavinayak Darshan Cab for families, pilgrims, and devotees visiting the eight sacred Ganpati temples of Maharashtra. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth and spiritual journey. Our service includes doorstep pickup from Pune, flexible one-day and multi-day darshan packages, 24/7 support, and transparent pricing, ensuring a peaceful and hassle-free pilgrimage experience.",

topPlaces: [
    {
        title: "Morgaon Mayureshwar Ganpati",
        description:
            "Morgaon Mayureshwar Ganpati is considered the starting point of the Ashtavinayak pilgrimage and is one of the most important temples dedicated to Lord Ganesha. The temple is known for its beautiful stone architecture, spiritual atmosphere, and deep religious significance among devotees."
    },
    {
        title: "Siddhatek Siddhivinayak",
        description:
            "Siddhatek Siddhivinayak Temple is located on the banks of the Bhima River and is famous for its peaceful surroundings and divine energy. It is believed that Lord Vishnu worshipped Lord Ganesha here before defeating demons, making it highly sacred."
    },
    {
        title: "Pali Ballaleshwar Ganpati",
        description:
            "Pali Ballaleshwar Temple is unique as it is the only Ashtavinayak temple named after a devotee of Lord Ganesha. The temple is surrounded by scenic hills and is known for its spiritual importance and historical legends."
    },
    {
        title: "Mahad Varadvinayak",
        description:
            "Mahad Varadvinayak Temple is one of the oldest Ganpati temples in Maharashtra, known for its serene environment and self-manifested idol. Devotees visit to seek blessings for success and removal of obstacles."
    },
    {
        title: "Theur Chintamani Ganpati",
        description:
            "Theur Chintamani Ganpati Temple is located near Pune and is known as a powerful place for mental peace and stress relief. It holds strong spiritual importance and is frequently visited during Ashtavinayak tours."
    },
    {
        title: "Lenyadri Girijatmaj Ganpati",
        description:
            "Lenyadri Temple is uniquely located inside ancient Buddhist caves on a hill. It is believed to be the birthplace of Lord Ganesha and offers a trekking experience along with spiritual darshan."
    },
    {
        title: "Ozar Vighnahar Ganpati",
        description:
            "Ozar Vighnahar Temple is a beautiful and well-maintained temple known for its large structure, peaceful environment, and importance in removing obstacles from devotees' lives."
    },
    {
        title: "Ranjangaon Mahaganpati",
        description:
            "Ranjangaon Mahaganpati Temple is one of the most powerful Ashtavinayak temples, believed to be visited by Lord Shiva before defeating evil forces. It is known for its grand idol and spiritual significance."
    },
    {
        title: "Kedgaon Temples Route",
        description:
            "The Kedgaon and surrounding rural routes offer scenic countryside views during the Ashtavinayak journey, making the road trip peaceful and spiritually refreshing for pilgrims."
    },
    {
        title: "Bhima River Scenic Route",
        description:
            "The Bhima River route connects several Ashtavinayak temples and offers beautiful natural views, small villages, and calm surroundings, enhancing the overall pilgrimage travel experience."
    }
],



services: [
{
name: "Pune to Ashtavinayak Cab",
description: "Rising Cab Service offers Pune to Ashtavinayak Cab for a smooth and spiritual journey covering the eight sacred Ganpati temples of Maharashtra. We provide well-maintained AC vehicles, experienced drivers familiar with temple routes, doorstep pickup, and flexible travel plans for families and pilgrims seeking a peaceful darshan experience."
},
{
name: "Ashtavinayak Darshan Cab Pune",
description: "Book Ashtavinayak Darshan Cab Pune with Rising Cab Service for a complete pilgrimage experience covering all Ashtavinayak temples in a comfortable and well-planned itinerary. Our service ensures safe driving, timely temple visits, and flexible halts for darshan and rest throughout the journey."
},
{
name: "Pune Ashtavinayak Taxi Service",
description: "Our Pune Ashtavinayak Taxi Service provides reliable and comfortable travel for devotees planning the sacred Ashtavinayak Yatra. Enjoy professional chauffeurs, clean vehicles, and customized routes designed for smooth temple visits across Maharashtra."
},
{
name: "Cab for Ashtavinayak Yatra Pune",
description: "Rising Cab Service offers Cab for Ashtavinayak Yatra Pune with dedicated vehicles for full-day or multi-day pilgrimage tours. We ensure comfortable seating, experienced drivers, and flexible schedules for a stress-free spiritual journey."
},
{
name: "Pune to Ashtavinayak Tour Cab",
description: "Book Pune to Ashtavinayak Tour Cab for a well-organized religious trip covering all major Ganpati temples with comfortable travel, safe driving, and customizable tour plans for families and groups."
},
{
name: "Ashtavinayak Darshan Taxi Pune",
description: "Our Ashtavinayak Darshan Taxi Pune service ensures a peaceful and convenient pilgrimage experience with well-maintained cars, professional drivers, and complete route coverage of all Ashtavinayak temples."
},
{
name: "Pune Religious Cab Ashtavinayak",
description: "Rising Cab Service provides Pune Religious Cab Ashtavinayak for devotees seeking a spiritual journey with safe transportation, flexible stops, and complete temple coverage across the Ashtavinayak circuit."
},
{
name: "Pune Temple Darshan Cab",
description: "Book Pune Temple Darshan Cab for visiting multiple temples around Pune and nearby regions with comfortable vehicles, experienced drivers, and customized spiritual travel plans."
},
{
name: "One Day Ashtavinayak Cab Pune",
description: "Our One Day Ashtavinayak Cab Pune service is designed for quick pilgrimage tours covering major temples in a single day with well-planned routes, early start, and efficient travel management."
},
{
name: "Pune Pilgrimage Cab Ashtavinayak",
description: "Rising Cab Service offers Pune Pilgrimage Cab Ashtavinayak for devotees seeking a complete spiritual journey with safe driving, flexible itinerary, and comfortable travel experience."
},
{
name: "Best Ashtavinayak Cab Pune",
description: "Book Best Ashtavinayak Cab Pune for top-quality service, experienced drivers, clean vehicles, and well-planned temple visits ensuring a smooth and memorable pilgrimage."
},
{
name: "SUV Ashtavinayak Cab Pune",
description: "Our SUV Ashtavinayak Cab Pune service provides spacious and comfortable travel options ideal for families and groups undertaking the Ashtavinayak Yatra across Maharashtra."
},
{
name: "Innova Ashtavinayak Cab Pune",
description: "Rising Cab Service offers Innova Ashtavinayak Cab Pune for premium comfort, ample seating space, and smooth long-distance travel during the full Ashtavinayak pilgrimage."
},
{
name: "Sedan Ashtavinayak Cab Pune",
description: "Book Sedan Ashtavinayak Cab Pune for affordable and comfortable travel suitable for small families and couples planning the Ashtavinayak temple tour."
},
{
name: "Ashtavinayak Yatra Booking Pune",
description: "Our Ashtavinayak Yatra Booking Pune service allows easy reservation of complete pilgrimage packages with flexible schedules, professional drivers, and customized travel plans."
},
{
name: "Ashtavinayak Tour Package Pune",
description: "Rising Cab Service offers Ashtavinayak Tour Package Pune with complete temple coverage, comfortable transportation, and well-planned itineraries for a peaceful spiritual journey."
},
{
name: "Ashtavinayak Darshan 2 Days Package Pune",
description: "Book Ashtavinayak Darshan 2 Days Package Pune for a relaxed pilgrimage covering all eight temples with overnight stays, flexible travel timing, and comfortable cab service."
},
{
name: "Ashtavinayak Tour from Pune by Bus Package",
description: "Our Ashtavinayak Tour from Pune by Bus Package provides group travel options with comfortable buses, planned routes, and complete temple darshan support for large families and groups."
}
],

tableData: [
["Pune to Ashtavinayak Cab","Ashtavinayak Darshan Cab Pune"],
["Pune Ashtavinayak Taxi Service","Cab for Ashtavinayak Yatra Pune"],
["Pune to Ashtavinayak Tour Cab","Ashtavinayak Darshan Taxi Pune"],
["Pune Religious Cab Ashtavinayak","Pune Temple Darshan Cab"],
["One Day Ashtavinayak Cab Pune","Pune Pilgrimage Cab Ashtavinayak"],
["Best Ashtavinayak Cab Pune","SUV Ashtavinayak Cab Pune"],
["Innova Ashtavinayak Cab Pune","Sedan Ashtavinayak Cab Pune"],
["Ashtavinayak Yatra Booking Pune","Ashtavinayak Tour Package Pune"],
["Ashtavinayak Darshan 2 Days Package Pune","Ashtavinayak Tour from Pune by Bus Package"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Ashtavinayak Darshan Cab Service",
        WhyChoosedescription: "Rising Cab Service offers reliable Pune to Ashtavinayak Darshan cab packages for devotees, families, senior citizens, and pilgrimage groups seeking a peaceful spiritual journey."
    },
    {
        WhyChooseheading: "Cover All Eight Sacred Ganpati Temples",
        WhyChoosedescription: "Our Ashtavinayak tour packages help devotees conveniently visit Morgaon, Siddhatek, Pali, Mahad, Theur, Lenyadri, Ozar, and Ranjangaon temples."
    },
    {
        WhyChooseheading: "Customized One-Day and Multi-Day Tours",
        WhyChoosedescription: "Travelers can choose same-day Ashtavinayak Darshan, two-day pilgrimage tours, weekend packages, or customized itineraries based on their schedule."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Pilgrimage Travel",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to group size and travel requirements."
    },
    {
        WhyChooseheading: "Ideal for Families and Senior Citizens",
        WhyChoosedescription: "Our cab service provides comfortable transportation with flexible schedules, making temple visits convenient for devotees of all age groups."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Temple Routes",
        WhyChoosedescription: "Our professional drivers are familiar with all Ashtavinayak temple routes and ensure a smooth, safe, and comfortable pilgrimage experience."
    },
    {
        WhyChooseheading: "Hassle-Free Religious Travel Planning",
        WhyChoosedescription: "Rising Cab Service helps devotees focus on their spiritual journey while we take care of transportation and travel arrangements."
    }
]
};

const faqData = [
    {
        question: "What is included in the Pune to Ashtavinayak Darshan Cab Package?",
        answer: "The package covers visits to all eight Ashtavinayak Ganpati temples along with comfortable cab transportation and flexible travel planning."
    },
    {
        question: "Which temples are covered in the Ashtavinayak Yatra?",
        answer: "The tour includes Morgaon, Siddhatek, Pali, Mahad, Theur, Lenyadri, Ozar, and Ranjangaon Ganpati temples."
    },
    {
        question: "Can I complete Ashtavinayak Darshan in one day?",
        answer: "Yes, one-day packages are available, although many devotees prefer two-day tours for a more relaxed pilgrimage experience."
    },
    {
        question: "Which vehicle is suitable for family pilgrimage travel?",
        answer: "Ertiga and Innova Crysta are among the most preferred vehicles because of their spacious seating and travel comfort."
    },
    {
        question: "Are Tempo Travellers available for groups?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for family groups, religious organizations, and group pilgrimages."
    },
    {
        question: "Can senior citizens comfortably travel on the Ashtavinayak route?",
        answer: "Yes, private cab transportation offers flexibility and comfort, making it ideal for senior citizens and families."
    },
    {
        question: "Can temple visit timings be customized?",
        answer: "Yes, travel schedules can be adjusted according to Darshan preferences, group requirements, and travel plans."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, devotees can start their pilgrimage from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "Is advance booking recommended for Ashtavinayak tours?",
        answer: "Yes, advance reservations are advisable during weekends, Ganesh festivals, public holidays, and peak pilgrimage seasons."
    },
    {
        question: "How can I book a Pune to Ashtavinayak Darshan Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Vishal Kulkarni",
        feedback:
            "Completing the Ashtavinayak Yatra with my family became a memorable experience. The vehicle was comfortable, the route planning was excellent, and the entire pilgrimage was stress-free.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Anuradha Joshi",
        feedback:
            "The Darshan tour was organized beautifully. We visited all eight Ganpati temples comfortably, and the driver's knowledge of the routes made the journey smooth and enjoyable.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Ashtavinayak Darshan Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-ashtavinayak-cab.jpg",
"description": "Book Pune to Ashtavinayak Darshan Cab Service with Rising Cab Service for a safe and comfortable pilgrimage tour of Ashtavinayak temples. Enjoy one-day and round-trip cab service with AC sedans, SUVs, and Innova cars.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-ashtavinayak-cab"
}
};




    return (
        <div>


<Helmet>
  <title>Pune to Ashtavinayak Darshan Cab | Temple Yatra Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Ashtavinayak Darshan Cab Service for a safe and comfortable temple pilgrimage tour. Get reliable one-day and round-trip taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to ashtavinayak cab, ashtavinayak darshan cab pune, pune ashtavinayak taxi service, cab for ashtavinayak yatra pune, pune to ashtavinayak tour cab, ashtavinayak darshan taxi pune, pune religious cab ashtavinayak, pune temple darshan cab, one day ashtavinayak cab pune, pune pilgrimage cab ashtavinayak, best ashtavinayak cab pune, suv ashtavinayak cab pune, innova ashtavinayak cab pune, sedan ashtavinayak cab pune, ashtavinayak yatra booking"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/67.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoashtavinayakdarshancab;